import _extends from "@babel/runtime/helpers/extends";
import { createContext } from 'react';
import jss, { create as originalCreateJss, createGenerateId as originalCreateGenerateId } from 'jss';
import { createTheming, SheetsRegistry } from 'react-jss';
import preset from 'jss-preset-default';
export var RAMBLER_UI_CLASS_NAME_PREFIX = 'rui-';
export var RAMBLER_UI_DISPLAY_NAME_PREFIX = '__RAMBLER_UI_DISPLAY_NAME_PREFIX__';
export var ThemeContext = createContext({});
export var ThemeProviderContext = createContext({});
export var theming = createTheming(ThemeContext);
var JssThemeProvider = theming.ThemeProvider,
    withTheme = theming.withTheme,
    useTheme = theming.useTheme;
export { JssThemeProvider, withTheme, useTheme };
export var createJss = function createJss() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return originalCreateJss(_extends({}, preset(options), {}, options));
};
export var createSheetsRegistry = function createSheetsRegistry() {
  return new SheetsRegistry();
};
export var globalJss = createJss();
export var globalSheetsRegistry = createSheetsRegistry();
export var createGenerateId = function createGenerateId() {
  var themeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var generateId = originalCreateGenerateId();
  return function (rule, sheet) {
    var displayNamePrefix = sheet ? sheet.options[RAMBLER_UI_DISPLAY_NAME_PREFIX] : '';
    if (!displayNamePrefix) return generateId(rule, sheet);
    var jssId = sheet ? sheet.options.jss.id : globalJss.id;
    var jssCounter = jssId === globalJss.id ? '' : "-".concat(jssId);
    var themeCounter = themeId === 0 ? '' : "-".concat(themeId);
    return RAMBLER_UI_CLASS_NAME_PREFIX + displayNamePrefix + rule.key + jssCounter + themeCounter;
  };
};
jss.setup({
  createGenerateId: createGenerateId
});